import CompanyNewModal from "company/new/App";
import SelectCompanyFromList from "company/selectFromList/app";
import { Modal } from "components";
import { ButtonPrimary, ButtonSecondary } from "components/Atoms/Button";
import React from "react";

interface Props {
  onClose: () => void
  onCompanyLinked: (companyId: number) => void
  contactId: number
  excludeKeys: number[]
}

const NewCompanyModal = (props: Props) => {
  const [displaySelectCompanyModal, setDisplaySelectCompanyModal] = React.useState(false);
  const [displayNewCompanyModal, setDisplayNewCompanyModal] = React.useState(false);

  const onCreateClicked = () => {
    setDisplayNewCompanyModal(true);
  };

  const onLinkClicked = () => {
    setDisplaySelectCompanyModal(true);
  };

  const onCompanySelected = async (c: server.dto.CompanySmall) => {
    props.onCompanyLinked(c.companyId);
  };

  return <>
    {displayNewCompanyModal && <CompanyNewModal
      onClose={() => setDisplayNewCompanyModal(false)}
      onCreated={c => {
        props.onCompanyLinked(c.companyId);
        setDisplayNewCompanyModal(false);
      }}
    />}
    <Modal
      title={""}
      style={{ width: 350 }}
      displayHeader={false}
      isOpen
      gap="regular"
      handleClose={props.onClose}
    >
      <ButtonPrimary
        onClick={onCreateClicked}
        label={RESX.Company.NewCompany}
      />

      <ButtonSecondary
        onClick={onLinkClicked}
        label={RESX.Company.LinkExistingCompany}
      />
    </Modal >

    <Modal
      title={RESX.Company.LinkExistingCompany}
      isOpen={displaySelectCompanyModal}
      handleClose={() => { setDisplaySelectCompanyModal(false); }}
      width="small"
      height={700}
    >
      <SelectCompanyFromList
        onCompanySelected={onCompanySelected}
        initialInstruction={{
          excludeKeys: props.excludeKeys
        }}
      />
    </Modal>
  </>;
};

export default NewCompanyModal;